module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n\n<div name=\"form-content\" class=\"wh100 content\" style=\"height: 58vh; padding: 0\">\n\n	<div class=\"_flex-item _relative\" name=\"map-side\">\n		<div name=\"map\" class=\"wh100 absolute\"></div>\n		<!--<div class=\"search-panel\">\n			<input type=\"text\" name=\"search\" placeholder=\"Поиск\"/>\n		</div>-->\n	</div>\n\n    ")
    ; //- UI.Template.render(widget.itemTemplate, locals) 

    ; __append("\n</div>\n")
  }
  return __output.join("");

}